export default {
    data: function() {
        return {
            is_admin: 0,
            permissions: null
        }
    },

    /**
     * Define as informações necessárias
     * @param {boolean} is_admin flag se é um usuário admin
     * @param {object} permissions lista das permissões por área
     */
    setData: function(is_admin, permissions) {
        this.is_admin = is_admin;
        this.permissions = permissions;
    },

    /**
     * Retorna se o usuário é administrador
     * @returns boolean se é um administrador
     */
    virifyIsAdmin: function() {
        return this.is_admin;
    },

    /**
     * Retorna as permissões do usuário
     * @returns object lista das permissões por seção
     */
    getPermissions: function() {
        return this.permissions;
    },

    /**
     * Retorna as permissões de uma seção
     * @param {string} area nome da classe da seção
     * @returns lista das permições da seção
     */
    getAreaPermissions: function(area) {
        if (typeof this.permissions[area] !== "undefined")
            return this.permissions[area].permissions;
        else
            return [];
    },

    /**
     * Retorna se o usuário tem permissão de acessar a seção
     * @param {string} area 
     * @returns se o usuário tem permissão para a seção
     */
    hasAreaPermission: function(area) {
        if (this.virifyIsAdmin())
            return true;
        else {
            if (typeof this.permissions[area] !== "undefined")
                return this.permissions[area].active;
            else
                return false;
        }
    },
    
    /**
     * Retorna se o usuário tem permissão visualizar a seção
     * @param {string} area 
     * @returns se o usuário pode visualizar
     */
    hasAreaReadPermission: function(area) {
        if (this.virifyIsAdmin())
            return true;
        else {
            if (typeof this.permissions[area] !== "undefined") {
                if (this.permissions[area].active)
                    return this.permissions[area].permissions.read;
                else
                    return false;
            }
            else
                return false;
        }
    },
    
    /**
     * Retorna se o usuário tem permissão editar a seção
     * @param {string} area 
     * @returns se o usuário pode editar
     */
    hasAreaEditPermission: function(area) {
        if (this.virifyIsAdmin())
            return true;
        else {
            if (typeof this.permissions[area] !== "undefined") {
                if (this.permissions[area].active)
                    return this.permissions[area].permissions.edit;
                else
                    return false;
            }
            else
                return false;
        }
    },
}